import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

const CargoManagementPage = loadable(
  async () => import("~/features/cargo/pages/CargoManagementPage"),
  { fallback: <></> },
)

const CreateCargoPage = loadable(
  async () => import("~/features/cargo/pages/CreateCargoPage"),
  { fallback: <></> },
)

export const cargoRoutes: RouteObject[] = [
  {
    path: "/cargo-management",
    element: <CargoManagementPage />,
    children: [
      {
        path: "create-cargo",
        element: <CreateCargoPage />,
      },
    ],
  },
]
